import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { forgotPassword } from "../../http/auth";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/slices/common";
import { useNavigate } from "react-router-dom";
import routePaths from '../../router/route-paths';

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = React.useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const data = new FormData(event.currentTarget);
      const res = await forgotPassword({
        email: data.get("email"),
      });
      if (res.status === 200) {
        setEmail("");
        dispatch(
          showToast({ color: "success", msg: "Email sent successfully" })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const onClickBack = () => {
    navigate(routePaths.HOME);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <LockOutlinedIcon />
        </Avatar> */}
        <Typography component="h1" variant="h5">
          Reset Password
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus

            value={email}
            onChange={handleChange}
            sx={{
              "& input": {
                fontSize: "18px",
                padding: "14px",
                color: "#142C5C",
              },
              "& .MuiFormLabel-root.Mui-focused": { color: "#142C5C" },
              "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#142C5C !important",

              },
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              background: "#142C5C",
              borderRadius: "80px",
              "&:hover": { background: "#142C5C" },
            }}
          >
            Send Email
          </Button>
        </Box>
        <Typography
          sx={{
            color: "#67697A",
            fontSize: "14px",
            width: "100%",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          Back to{" "}
          <span
            style={{ color: "#142C5C", cursor: "pointer", fontWeight: "600" }}
            onClick={onClickBack}
          >
            Sign In
          </span>
        </Typography>
      </Box>
    </Container>
  );
}
